import React, { useState, useEffect } from "react";
import PaymentHistory from "./PaymentHistory";
import InstallmentFip from "./InstallmentFip";
import InstallmentPif from "./InstallmentPif";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Request";
import Enach from "./Enach";
import AddPayment from "./AddPayment";
import Adjustment from "./Adjustment";
import Settlement from "./Statement";
import privilegeList from "../../PrivilegeList";
import { URL } from "../../api";

import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

const Installment = () => {
  const { cid, lid } = useParams();
  const [activePage, setActivePage] = useState("payment-history");
  const [loading, setLoading] = useState(false);

  const handleTabClick = (page) => {
    setActivePage(page);
  };

  useEffect(() => {
    if (activePage === "payment") {
      setLoading(true);
      axiosInstance
        .get(`${URL.ENACH_LIST}?customerId=${cid}&loanId=${lid}`)
        .then((response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          console.log("API Data:", data);
        })
        .catch((error) => {
          console.error("Error fetching Razorpay order info:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [activePage, cid, lid]);

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "N/A";
    try {
      return new Date(dateTime).toLocaleString();
    } catch (e) {
      return "Invalid Date";
    }
  };

  return (
    <Card className="bg-secondary shadow">
      <CardHeader className="bg-white border-0">
        <Row className="align-items-center">
          <Col xs="8">
            <h3 className="mb-0">Installment &amp; Collection</h3>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activePage === "payment-history" ? "active" : ""}
              onClick={() => handleTabClick("payment-history")}
            >
              Payment History
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activePage === "installment-flip" ? "active" : ""}
              onClick={() => handleTabClick("installment-flip")}
            >
              Installment FIP
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activePage === "installment-paid" ? "active" : ""}
              onClick={() => handleTabClick("installment-paid")}
            >
              Installment PIF
            </NavLink>
          </NavItem>
           {privilegeList.installmentAdjustmentTabShow && (
          <NavItem>
            {/* <NavLink
              className={activePage === "adjustment" ? "active" : ""}
              onClick={() => handleTabClick("adjustment")}
            >
              Adjustment
            </NavLink> */}
          </NavItem>
           )}
          <NavItem>
            <NavLink
              className={activePage === "add-payment" ? "active" : ""}
              onClick={() => handleTabClick("add-payment")}
            >
              Add Payment
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activePage === "payment" ? "active" : ""}
              onClick={() => handleTabClick("payment")}
            >
              Enach
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activePage === "settlement" ? "active" : ""}
              onClick={() => handleTabClick("settlement")}
            >
              Statement
            </NavLink>
          </NavItem>
        </Nav>

        {activePage === "payment-history" && <PaymentHistory cid={cid} lid={lid} />}
        {activePage === "installment-flip" && <InstallmentFip />}
        {activePage === "installment-paid" && <InstallmentPif />}
        {activePage === "add-payment" && <AddPayment />}
        {activePage === "adjustment" && <Adjustment />}
        {activePage === "payment" && <Enach />}
        {activePage === "settlement" && <Settlement />}
      </CardBody>
    </Card>
  );
};

export default Installment;
